import { Link } from 'react-router-dom'
import { client } from '../../hooks/Client'
import { useFirestoreGeneral } from '../../firebase/useFirestore'

// AI-CONTEXT: See docs/features/adres-koppeling-algemene-qr.md

/**
 * Verbindt de trajecten op één adres. Een nieuw traject op een afgerond adres
 * is een eigen huishouden met `PreviousAdressID` (koppeling op adres, keuze
 * 'Nieuw traject'); hier staat een link naar het eerdere en naar het latere.
 *
 * Toont niets zolang een van de twee lijsten laadt: de hook geeft dan '' —
 * en ook bij een overgeslagen query (geen PreviousAdressID), wat hier
 * hetzelfde betekent: niets te tonen.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {object} props
 * @param {{ID: string, PreviousAdressID?: string}} props.adress - Het huishouden van deze pagina
 */
const PreviousTrajectLink = ({ adress }) => {
    const previous = useFirestoreGeneral('Adresses', 'ID', adress?.PreviousAdressID || '')
    const next = useFirestoreGeneral('Adresses', 'PreviousAdressID', adress?.ID || '')

    const links = [
        Array.isArray(previous) && previous[0] && { label: 'Eerder traject op dit adres', household: previous[0] },
        Array.isArray(next) && next[0] && { label: 'Later traject op dit adres', household: next[0] },
    ].filter(Boolean)

    if (links.length === 0) return null

    return (
        <div className='previous-traject-links'>
            {links.map(({ label, household }) => (
                <p key={household.ID}>
                    {label}:{' '}
                    <Link to={`/${client}/adressdetails/${household.ID}`}>{household.Title || 'Huishouden'}</Link>
                </p>
            ))}
        </div>
    )
}

export default PreviousTrajectLink
